import { render, staticRenderFns } from "./UiSection.vue?vue&type=template&id=72bbf6ea&"
import script from "./UiSection.vue?vue&type=script&lang=js&"
export * from "./UiSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports